import CssBaseline from '@mui/material/CssBaseline';
import LeftSubDrawer from './Components/LeftSubDrawer/LeftSubDrawer.component';
import MapArea from './Components/MapArea/MapArea.component';
import { useEffect, useRef, useState } from 'react';
import ContentBottomDrawer from './Components/BottomDrawer/BottomDrawer.component';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IntroDialog from './Components/Intro/IntroDialog.component';
import NavbarCustom from './Components/Navbar/NavbarCustom.component';
import LeftMainDrawer from './Components/LeftMainDrawer/LeftMainDrawer.component';
import config from "./config.json";
import getBundeslandData from "./Services/getBundeslandData"
import { PinDropSharp } from '@mui/icons-material';
export default function MainPage() {

    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    const drawerWidth = 300;
    const leftDrawerWidthMobile = "70%";
    const leftDrawerWidthDesktop = "300px";

    const [leftMainDrawerOpen, setLeftMainDrawerOpen] = useState<boolean>(false);
    const [leftSubDrawerType, setLeftSubDrawerType] = useState<any>("BAUMARTEN");
    const [leftSubDrawerOpen, setLeftSubDrawerOpen] = useState<boolean>(false);

    const [legendOpen, setLegendOpen] = useState(false)

    const [bottomDrawerOpen, setBottomDrawerOpen] = useState(true);
    const [bundesland, setBundesland] = useState<string>('BAYERN');
    const [selectedAreaId, setSelectedAreaId] = useState('')
    const [statisticsBundesland, setStatisticsBundesland] = useState(null);
    const [mapBounds, setMapBounds] = useState<any>(null)
    const [activeLayer, setActiveLayer] = useState("baumarten"); //default layer
    const [tabIndexWaldzustand, setTabIndexWaldzustand] = useState(0);
    const [inIframe, setInIframe] = useState(false);
    const [increaseButtonOffsetMobile, setIncreaseButtonOffsetMobile] = useState(false)

    const [version, setVersion] = useState('2016_2020');

    useEffect(() => {

        if ((leftSubDrawerType == "BAUMARTEN") || (leftSubDrawerType == "BAUMARTEN")) {
            setLegendOpen(true)
        }
    }, [leftSubDrawerType])




    const useDidMountEffect = (func: any, deps: any) => {
        // Prevents re-render on inital load
        const didMount = useRef(false);
        useEffect(() => {
            if (didMount.current) func();
            else didMount.current = true;
        }, deps);
    }

    // Bundesland change
    useDidMountEffect(() => {
        const stats = getBundeslandData(bundesland)
        setStatisticsBundesland(stats)
        setBottomDrawerOpen(true)
        mobile && setIncreaseButtonOffsetMobile(true)
    }, [bundesland])


    useEffect(() => {
        // typescript necessity to check if not null
        if (statisticsBundesland != null) {
            setMapBounds(statisticsBundesland["bbox"])
            setSelectedAreaId(statisticsBundesland["RS"])
        }

    }, [statisticsBundesland])

    useEffect(() => {
        // When mobile, closing the subdrawer triggers close of main drawer
        mobile && (setLeftMainDrawerOpen(false))
    }, [leftSubDrawerOpen])

    useEffect(() => {
        if (window.location !== window.parent.location) {
            // The page is in an iframe
            setInIframe(true);
        }
    }, [])

    console.log(statisticsBundesland)
    const dummyStats =
    {
        "name": "Bayern",
        "label": "bayern",
        "bbox": [
            [
                47.2703623267,
                8.9771580802
            ],
            [
                50.5644529365,
                13.8350427083
            ]
        ],
        "baumarten": {
            "andereLaubbaumarten": 9.8,
            "buche": 13.3,
            "eiche": 3.6,
            "douglasie": 0,
            "fichte": 56,
            "kiefer": 17.3,
            "laerche": 0
        },
        "nadelwaldAnteil": 73.3,
        "laubwaldAnteil": 26.7,
        "waldfläche2017Ha": 2617976.5,
        "RS": "09",
        "Laub_lost_2016_2020": 5159,
        "Laub_lost_2020_2021": 1000,
        "Laub_lost_2021_2022": 2000,
        "Nadel_lost_2016_2020": 21292,
        "Nadel_lost_2020_2021": 2000,
        "Nadel_lost_2021_2022": 3000,
    }
    return (
        <>
            <CssBaseline />
            {inIframe || <IntroDialog />}
            <NavbarCustom
                setLeftMainDrawerOpen={setLeftMainDrawerOpen}
                mobile={mobile}
                leftDrawerWidthMobile={leftDrawerWidthMobile}
                leftDrawerWidthDesktop={leftDrawerWidthDesktop}
                setLeftSubDrawerOpen={setLeftSubDrawerOpen}
                setLeftSubDrawerType={setLeftSubDrawerType}
            />
            <LeftMainDrawer
                leftMainDrawerOpen={leftMainDrawerOpen}
                setLeftMainDrawerOpen={setLeftMainDrawerOpen}
                setLeftSubDrawerOpen={setLeftSubDrawerOpen}
                setLeftSubDrawerType={setLeftSubDrawerType}
                mobile={mobile}
                setActiveLayer={setActiveLayer}
                activeLayer={activeLayer}
                tabIndexWaldzustand={tabIndexWaldzustand}
            />
            <LeftSubDrawer
                leftSubDrawerOpen={leftSubDrawerOpen}
                setLeftSubDrawerOpen={setLeftSubDrawerOpen}
                leftSubDrawerType={leftSubDrawerType}
                leftDrawerWidthMobile={leftDrawerWidthMobile}
                leftDrawerWidthDesktop={leftDrawerWidthDesktop}
                bundesland={bundesland}
                setBundesland={setBundesland}
                mobile={mobile}
                setActiveLayer={setActiveLayer}
                setTabIndexWaldzustand={setTabIndexWaldzustand}
                tabIndexWaldzustand={tabIndexWaldzustand}
                version={version}
                setVersion={setVersion}
            />
            <MapArea
                drawerWidth={drawerWidth}
                setLeftSubDrawerType={setLeftSubDrawerType}
                leftSubDrawerType={leftSubDrawerType}
                setLeftSubDrawerOpen={setLeftSubDrawerOpen}
                leftSubDrawerOpen={leftSubDrawerOpen}
                mobile={mobile}
                setSelectedAreaId={setSelectedAreaId}
                selectedAreaId={selectedAreaId}
                setBundesland={setBundesland}

                legendOpen={legendOpen}
                setLegendOpen={setLegendOpen}
                mapBounds={mapBounds}
                activeLayer={activeLayer}
                setActiveLayer={setActiveLayer}
                tabIndexWaldzustand={tabIndexWaldzustand}
                increaseBottomOffsetMobile={increaseButtonOffsetMobile}
                setVersion={setVersion}
                version={version}
            />


            {statisticsBundesland &&
                <ContentBottomDrawer
                    drawerWidth={drawerWidth}
                    bottomDrawerOpen={bottomDrawerOpen}
                    setBottomDrawerOpen={setBottomDrawerOpen}
                    statisticsBundesland={statisticsBundesland}

                />}

        </>
    )

}